import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../_services/authenication.service';
import { EventsService } from "../../_services/events.service";

import { ToasterService } from '../../_services/toaster.service';

import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-eventbookingsdetail',
  templateUrl: './eventbookingsdetail.component.html',
  styleUrls: ['./eventbookingsdetail.component.css']
})
export class EventbookingsdetailComponent implements OnInit {

  userdetaild: string;
  baseUrl: string = environment.baseUrl;
  doctorid: string;
  returnUrl: string;
  id: string;
  booking_detail: any[] = [];

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute, private eventsservice: EventsService, private toaster: ToasterService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }

    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';



    this.id = this.route.snapshot.params.id;
    const payload = {
      id: this.id
    };
    this.getEventBookingByEventId(payload);
  }

  getEventBookingByEventId(id) {
    this.eventsservice.getEventBookingById(id)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.booking_detail = data.bookingDetail;

          } else {
            this.toaster.showError('Booking Detail', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('Booking Detail', error.error.ResponseMessage);
        });
  }

}
